module.exports = __webpack_public_path__ + "static/media/strutture-campo-calcetto-a5-genova-noleggiocampi.ff213b9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/calcetto/slider1/strutture-campo-calcetto-a5-genova-noleggiocampi.jpg
// module id = 642
// module chunks = 0